# +++++ Link Container Class +++++
class LinkContainer
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'link--container--bound'
            @.$el.classList.add 'link--container--bound'
            @.InitEvents()
        return
        
    
    InitEvents: ->
        return

BindLinkContainers = ->
    document.querySelectorAll '.link--container:not(.link--container--bound)'
        .forEach (el) ->
            new LinkContainer el
            return
    return

window.addEventListener 'bind-components', BindLinkContainers
